import { IronOutlineIcon } from './IronOutlineIcon';

/**
 * author: Google
 * id 82FEA1DA-69DE-436E-9D68-9116ADBE7D9B
 * name iron-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/iron-outline.svg
 * tags
 * - Home Automation 
 * - Clothing 
 */
export const FlatironOutlineIcon = IronOutlineIcon;
export default FlatironOutlineIcon